/** @format */
import { Loader } from '@mpb-com/feather/components/atoms/loader';
import { useTranslation } from 'next-i18next';
import React, { Fragment, useContext } from 'react';
import styled from 'styled-components';

import { documentToReactNode } from '@toucan/services/adapters/contentful';

import { useContentful } from '@toucan/client/blocks/hooks/use-contentful';
import {
    HelpPageContent,
    HelpPageContentQuery,
    HelpPageContentResponse,
} from '@toucan/client/features/contentful/config/page-data';
import { ApplicationContext } from '@toucan/client/global/application';
import { MarketContext } from '@toucan/client/global/market';
import { ContentfulQueryId } from '@toucan/common/contentful';

const StyledLoader = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 20rem;
`;

export const TermsAndConditionsModalContent = () => {
    const { t } = useTranslation();
    const { activeMarket } = useContext(MarketContext);
    const { legalLinks } = useContext(ApplicationContext);
    const helpSlug = t('help', { ns: 'urls' });

    const termsSlug =
        legalLinks?.termsPage?.urlSlug ??
        `${helpSlug}/${t('terms-and-conditions', { ns: 'urls' })}`;

    const { data, isLoading } = useContentful<
        HelpPageContentResponse,
        HelpPageContentQuery,
        HelpPageContent
    >(
        ContentfulQueryId.HELP_PAGE_CONTENT_BY_SLUG,
        {
            slug: termsSlug,
            market: activeMarket.code,
        },
        {
            select: (data) => {
                return data?.pageHelpCollection?.items[0];
            },
        }
    );

    const termsAndConditionsNode = data?.content.json
        ? documentToReactNode(data.content.json)
        : null;

    return (
        <Fragment>
            {isLoading ? (
                <StyledLoader data-testid="terms-and-conditions-modal__loader">
                    <Loader />
                </StyledLoader>
            ) : (
                termsAndConditionsNode
            )}
        </Fragment>
    );
};
